export const brandsData = [
    {
        id: 0,
        name: "Nike",
        icon: "nike",
        isSelected: false
    },
    {
        id: 1,
        name: "New Balance",
        icon: "newBalance",
        isSelected: false
    },
    {
        id: 2,
        name: "Brooks",
        icon: "brooks",
        isSelected: false
    },
    {
        id: 3,
        name: "Dell",
        icon: "dell",
        isSelected: false
    },
    {
        id: 4,
        name: "Sony",
        icon: "sony",
        isSelected: false
    },
    {
        id: 5,
        name: "Fender",
        icon: "fender",
        isSelected: false
    },
    {
        id: 6,
        name: "Target",
        icon: "target",
        isSelected: false
    },
    {
        id: 7,
        name: "Volkswagen",
        icon: "volkswagen",
        isSelected: false
    },
    {
        id: 8,
        name: "Live Nation",
        icon: "liveNation",
        isSelected: false
    },
    {
        id: 9,
        name: "Columbus Crew",
        icon: "columbusCrew",
        isSelected: false
    },
]
